import { Component, Input, OnInit } from '@angular/core';
import { LocationService } from '../../../services/location.service';
import { ReleaseService } from '../../../services/release.service';

@Component({
	selector: 'bb-about',
	templateUrl: './bb-about.component.html',
	styleUrls: ['./bb-about.component.scss']
})

export class BbAboutComponent implements OnInit {
	@Input('theme') theme?: 'rb' | '' = '';

	buildDate: any;
	release: string;
	serverUrl: string;

	constructor(private locationService: LocationService, private releaseService: ReleaseService) { }

	ngOnInit() {
		this.buildDate = this.releaseService.buildDate;
		this.release = this.releaseService.release;
		this.serverUrl = this.locationService.server;
	}
}
